if (!customElements.get("custom-product-form")) {
  customElements.define(
    "custom-product-form",
    class CustomProductForm extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.form = this.querySelector("form");

        if (!this.form) {
          console.error("No form found inside <custom-product-form>");
          return;
        }

        const checkedInputs = document.querySelectorAll(
          '.complementary-products input[type="checkbox"]:checked'
        );
        checkedInputs.forEach((input) => {
          input.checked = false;
        });

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.submitButton = this.form.querySelector('button[type="submit"]');

        if (!this.submitButton) {
          console.error("No submit button found inside <custom-product-form>");
        }

        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form.reportValidity()) return;
        let items = [];

        // --- Main product
        const mainQtyInput = document.querySelector(
          ".quantity-selector__input"
        );
        const mainQty = parseInt(mainQtyInput?.value || 1, 10);
        items.push({
          id: this.submitButton.dataset.mainProdId,
          quantity: mainQty,
        });

        // --- Complementary products
        const complementaryProdContainer = document.querySelector(
          ".complementary-products"
        );
        if (complementaryProdContainer) {
          const checkboxes = complementaryProdContainer.querySelectorAll(
            'input[type="checkbox"]:checked'
          );
          checkboxes.forEach((checkbox) => {
            const checkboxContainer = checkbox.closest(".shop-the-look-item");
            const sizeSelector = checkboxContainer.querySelector(
              ".shop-the-look-size-selector"
            );
            if (sizeSelector && sizeSelector.value) {
              items.push({
                id: sizeSelector.value,
                quantity: 1,
              });
            }
          });
        }

        // --- Build FormData
        const formData = new FormData();
        items.forEach((item, index) => {
          formData.append(`items[${index}][id]`, item.id);
          formData.append(`items[${index}][quantity]`, item.quantity);
        });

        const sections = this.getSectionsToRender()
          .map((section) => section.section)
          .join(",");
        formData.append("sections", sections);
        formData.append("sections_url", window.location.pathname);

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
          body: formData,
        };

        fetch(`${Shopify.routes.root}cart/add.js`, config)
          .then((res) => res.json())
          .then(async (res) => {
            if (res.status) {
              this.handleErrorMessage(res.description);
              return;
            }

            // ✅ Get fresh cart JSON
            const cart = await fetch(`${Shopify.routes.root}cart.js`).then(
              (r) => r.json()
            );

            // ✅ Attach rendered sections from add.js
            if (res.sections) {
              cart.sections = res.sections;
              this.renderContents({ sections: res.sections });
            } else {
              console.warn("⚠️ No sections returned from Shopify!");
            }

            // ✅ Fire Dawn-style custom events
            this.dispatchEvent(
              new CustomEvent("variant:add", {
                bubbles: true,
                detail: {
                  items: res.hasOwnProperty("items") ? res.items : [res],
                  cart,
                },
              })
            );

            document.documentElement.dispatchEvent(
              new CustomEvent("cart:change", {
                bubbles: true,
                detail: { baseEvent: "variant:add", cart },
              })
            );

            // 🟢 Open Impact cart drawer
            const drawer = document.getElementById("cart-drawer");
            if (drawer) {
              drawer.classList.add("active");
              document.body.classList.add("open-cart", "open-cc");
              document.dispatchEvent(new CustomEvent("cart-drawer:open"));
            } else {
              console.warn("⚠️ No #cart-drawer element found in DOM!");
            }
          })
          .catch((err) => {
            console.error("❌ Fetch error in onSubmitHandler:", err);
            this.handleErrorMessage("Something went wrong. Please try again.");
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove("loading");
              this.submitButton.removeAttribute("aria-disabled");
            }
          });
      }

      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const container = document.getElementById(section.id);
          if (!container) {
            console.warn("⚠️ No element with ID:", section.id);
            return;
          }

          const elementToReplace =
            container.querySelector(section.selector) || container;
          const html = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          if (!html) {
            console.error("❌ No HTML found for section:", section.section);
          }
          elementToReplace.innerHTML = html;

          if (section.id === "Cart-Drawer") {
            document.getElementById("Cart-Drawer")?.notesToggle();
            document.getElementById("Cart-Drawer")?.removeProductEvent();
          }
          if (section.id === "Cart" && typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });
      }

      getSectionInnerHTML(html, selector = ".shopify-section") {
        if (!html) {
          console.warn("⚠️ Empty HTML for selector:", selector);
          return "";
        }
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const el = parsed.querySelector(selector);
        if (!el) {
          console.error(
            "❌ Could not find selector",
            selector,
            "in section HTML"
          );
          return "";
        }
        return el.innerHTML;
      }

      getSectionsToRender() {
        return [
          {
            id: "cart-drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer", // 👈 same parent
            section: "cart-drawer",
            selector: ".cart-drawer__footer", // replace footer specifically
          },
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          },
          {
            id: "cart-live-region-text",
            section: "cart-live-region-text",
            selector: ".shopify-section",
          },
        ];
      }

      renderContents({ sections }) {
        this.getSectionsToRender().forEach(({ id, section, selector }) => {
          const container =
            document.getElementById(id) || this.querySelector(selector);
          const html = new DOMParser().parseFromString(
            sections[section],
            "text/html"
          );
          const updatedEl = html.querySelector(selector);

          if (container && updatedEl) {
            container.innerHTML = updatedEl.innerHTML;
          }
        });
      }

      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

function formatMoneyCents(cents) {
  const amount = parseInt(cents || 0, 10) / 100;

  // If Shopify.formatMoney exists, still respect it
  try {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      const fmt =
        window.Shopify.money_format ||
        (window.theme && window.theme.moneyFormat) ||
        "Rs. {{amount}}";
      return Shopify.formatMoney(cents, fmt);
    }
  } catch (e) {}

  // ✅ Custom Rs. prefix
  return `Rs. ${amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

if (!customElements.get("pair-well-with")) {
  customElements.define(
    "pair-well-with",
    class PairWellWith extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.form = this.querySelector("form");
        this.variantIdInput = this.form.querySelector("[name=id]");
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.totalPriceElement = document.getElementById(
          "shop-the-look-total-price"
        );
        this.checkboxes = document.querySelectorAll(".shop-the-look-checkbox");

        let currentVariant = null;

        const variantSelects = document.querySelector("variant-selects");

        if (variantSelects?.currentVariant) {
          currentVariant = variantSelects.currentVariant;
        }

        if (currentVariant) {
          this.onMainVariantChange({ detail: { variant: currentVariant } });
        }

        document.addEventListener("product:variant-change", (event) =>
          this.onMainVariantChange(event)
        );

        if (this.totalPriceElement && this.checkboxes.length) {
          this.initShopTheLook();
        }
      }

      onMainVariantChange(event) {
        const selectedVariant = event.detail.variant;
        if (!selectedVariant) return;

        const selectedVariantId = selectedVariant.id;
        const selectedVariantPrice = selectedVariant.price;

        if (this.variantIdInput) {
          this.variantIdInput.value = selectedVariantId;
        }

        if (this.submitButton) {
          this.submitButton.dataset.mainProdId = selectedVariantId;
        }

        if (this.totalPriceElement) {
          this.totalPriceElement.dataset.basePrice = selectedVariantPrice;
          this.updateTotalPrice(true);
        }
      }

      initShopTheLook() {
        this.submitButton.disabled = true;
        this.submitButton.classList.add("disabled-button");

        this.checkboxes.forEach((checkbox) => {
          checkbox.addEventListener("change", () => {
            this.updateTotalPrice();
            this.updateButtonState();
          });
        });

        document
          .querySelectorAll(".shop-the-look-size-selector")
          .forEach((selector) => {
            selector.addEventListener("change", (e) => {
              this.updateTotalPrice();
              this.updateButtonState();
              this.updateVariantImage(e.target);
            });
          });

        const mainQtyInput = document.querySelector(
          ".quantity-selector__input"
        );
        if (mainQtyInput) {
          mainQtyInput.addEventListener("change", (e) => {
            this.updateTotalPrice();
            this.syncBundleMainProductQty(e.target.value);
          });
        }

        this.updateTotalPrice();
        this.updateButtonState();
      }

      syncBundleMainProductQty(qty) {
        const secondAtcInput = document.querySelector(".second-atc-quantity");
        if (secondAtcInput) {
          secondAtcInput.value = qty;
        }
      }

      updateVariantImage(selector) {
        const selectedOption = selector.selectedOptions[0];
        if (!selectedOption) return;

        const newImage = selectedOption.dataset.image;
        const newPriceCents = parseInt(selectedOption.dataset.price || "0", 10);

        if (newImage) {
          const itemContainer = selector.closest(".shop-the-look-item");
          const picture = itemContainer.querySelector(
            ".shop-the-look-image picture"
          );
          const imgTag = picture?.querySelector("img");

          if (imgTag) {
            imgTag.src = newImage;
            imgTag.srcset = newImage;
          }
          if (picture) {
            picture.querySelectorAll("source").forEach((source) => {
              source.srcset = newImage;
            });
          }

          // 🔹 Update the displayed price for this item
          const priceTag = itemContainer.querySelector(".shop-the-look-price");
          if (priceTag) {
            priceTag.dataset.priceRaw = String(newPriceCents); // keep raw cents for totals
            priceTag.innerHTML = `<span class="money" data-cents="${newPriceCents}">${formatMoneyCents(
              newPriceCents
            )}</span>`;
          }
        }

        this.updateTotalPrice();
      }

      updateTotalPrice() {
        const mainQtyInput = document.querySelector(
          ".quantity-selector__input"
        );
        const mainproductQty = parseInt(mainQtyInput?.value || "1", 10);

        // base prices come in cents on your dataset
        const basePrice =
          parseFloat(this.totalPriceElement.dataset.basePrice || "0") / 100;
        const baseComparePrice =
          parseFloat(this.totalPriceElement.dataset.baseComparePrice || "0") /
          100;

        let total = basePrice * mainproductQty;
        let totalCompare = baseComparePrice * mainproductQty;

        this.checkboxes.forEach((checkbox) => {
          const item = checkbox.closest(".shop-the-look-item");
          const variantSelector = item.querySelector(
            ".shop-the-look-size-selector"
          );
          const selectedOption = variantSelector?.selectedOptions?.[0];

          const price = selectedOption
            ? parseFloat(selectedOption.dataset.price || "0") / 100
            : parseFloat(checkbox.dataset.price || "0") / 100;

          const comparePrice = selectedOption
            ? parseFloat(selectedOption.dataset.comparePrice || "0") / 100
            : parseFloat(checkbox.dataset.comparePrice || "0") / 100;

          // update each item’s visible price (even if not checked)
          const priceTag = item.querySelector(".shop-the-look-price");
          if (priceTag) {
            const itemCents = Math.round(
              selectedOption
                ? parseFloat(selectedOption.dataset.price || "0")
                : parseFloat(checkbox.dataset.price || "0")
            );
            priceTag.dataset.priceRaw = String(itemCents);
            priceTag.innerHTML = `<span class="money" data-cents="${itemCents}">${formatMoneyCents(
              itemCents
            )}</span>`;
          }

          if (checkbox.checked) {
            if (!isNaN(price)) total += price;
            if (!isNaN(comparePrice)) totalCompare += comparePrice;
          }
        });

        // convert back to cents for formatting
        const totalCents = Math.round(total * 100);
        const totalCompareCents = Math.round(totalCompare * 100);

        if (this.totalPriceElement) {
          this.totalPriceElement.innerHTML = `<span class="money" data-cents="${totalCents}">${formatMoneyCents(
            totalCents
          )}</span>`;
        }

        const comparePriceElement = document.getElementById(
          "shop-the-look-compare-price"
        );
        if (comparePriceElement) {
          comparePriceElement.innerHTML = `<span class="money" data-cents="${totalCompareCents}">${formatMoneyCents(
            totalCompareCents
          )}</span>`;
        }
      }

      updateButtonState() {
        let anyChecked = false;
        let allValid = true;

        this.checkboxes.forEach((checkbox) => {
          if (checkbox.checked) {
            anyChecked = true;

            const variantSelector = checkbox
              .closest(".shop-the-look-item")
              .querySelector(".shop-the-look-size-selector");

            if (!variantSelector || !variantSelector.value) {
              allValid = false;
            }
          }
        });

        if (anyChecked && allValid) {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove("disabled-button");
        } else {
          this.submitButton.disabled = true;
          this.submitButton.classList.add("disabled-button");
        }
      }
    }
  );
}
